// Website Creator: htutkhaung.ko@msgtech.co.th
import { getLanguage } from './i18n.js';

export const SOLUTIONS_DATA = [
  // ─── Enterprise Systems ───
  {
    id: 'erp-systems',
    category: 'enterprise',
    title: 'Enterprise ERP & Financial Systems',
    title_th: 'ระบบ ERP & การเงินระดับองค์กร',
    badge: 'Operations & Finance',
    badge_th: 'การบริหารและการเงิน',
    description: 'Unified multi-entity financial ledgers, 3-way invoice matching, automated accounts payable/receivable, asset tracking, tax reporting, and 0-day month-end closing.',
    description_th: 'รวมบัญชีแยกประเภทหลายนิติบุคคล ตรวจสอบใบแจ้งหนี้ 3 ทิศทาง จัดการเจ้าหนี้/ลูกหนี้อัตโนมัติ ติดตามสินทรัพย์ ยื่นภาษี และปิดงบสิ้นเดือนรวดเร็วในวันเดียว',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>`,
    tags: ['General Ledger (GL)', 'Accounts Payable/Receivable', '3-Way Matching', 'Asset Depreciation', 'Multi-Branch Audit'],
    tags_th: ['บัญชีแยกประเภท (GL)', 'ลูกหนี้/เจ้าหนี้', 'จับคู่เอกสาร 3 ทิศทาง', 'คำนวณค่าเสื่อมราคา', 'ตรวจสอบข้ามสาขา'],
  },
  {
    id: 'smart-inventory',
    category: 'enterprise',
    title: 'Smart Warehouse & Inventory Management',
    title_th: 'ระบบจัดการคลังและสต็อกอัจฉริยะ',
    badge: 'Supply Chain',
    badge_th: 'ห่วงโซ่อุปทาน & คลังสินค้า',
    description: 'Automated real-time stock deduction upon POS checkout, batch & expiry tracking, recipe portion costing, automated vendor PO reordering, and shrinkage elimination.',
    description_th: 'ตัดสต็อกตามสูตรอาหารทันทีเมื่อคิดเงินที่แคชเชียร์ POS ติดตามล็อตและวันหมดอายุ คำนวณต้นทุนวัตถุดิบ ออกใบสั่งซื้อ (PO) ซัพพลายเออร์อัตโนมัติ และตัดปัญหาสินค้าสูญหาย',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`,
    tags: ['BOM Recipe Costing', 'Auto Reordering', 'Batch & Expiry', 'Stock Audits', 'Vendor PO Portal'],
    tags_th: ['ตัดสต็อกสูตรอาหาร (BOM)', 'สั่งซื้อซัพพลายเออร์อัตโนมัติ', 'ตรวจวันหมดอายุ', 'ตรวจนับสต็อก', 'พอร์ทัลคู่ค้า'],
  },
  {
    id: 'hr-payroll',
    category: 'enterprise',
    title: 'HR & Biometric Payroll Solutions',
    title_th: 'ระบบบริหารงานบุคคล & เงินเดือนไบโอเมตริก',
    badge: 'Human Resources',
    badge_th: 'ทรัพยากรบุคคล',
    description: 'Automated biometric time & attendance logging, shift rota scheduling, overtime (OT) formula engines, Thai Social Security & Tax (P.N.D.1) compliance, and employee self-service.',
    description_th: 'บันทึกเวลาเข้า-ออกงานด้วยลายนิ้วมือหรือสแกนใบหน้า จัดกะการทำงาน คำนวณโอที (OT) อัตโนมัติ รองรับประกันสังคมและภาษี ภ.ง.ด.1 พร้อมพอร์ทัลพนักงานดูสลิปเงินเดือน',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>`,
    tags: ['Biometric Clocks', 'Shift Scheduling', 'OT Automation', 'Thai Tax Compliance', 'Employee Self-Service'],
    tags_th: ['สแกนนิ้ว/ใบหน้า', 'จัดตารางกะ', 'คำนวณโอทีอัตโนมัติ', 'รองรับภาษีไทย', 'ระบบบริการพนักงาน'],
  },
  {
    id: 'solution-architecture',
    category: 'enterprise',
    title: 'Enterprise Solution Architecture',
    title_th: 'ออกแบบสถาปัตยกรรมระบบองค์กร',
    badge: 'Core Infrastructure',
    badge_th: 'โครงสร้างพื้นฐานหลัก',
    description: 'Bespoke end-to-end technical blueprints, microservices, cloud-native deployments, high-availability databases, and resilient API bridges engineered to scale.',
    description_th: 'วางพิมพ์เขียวโครงสร้างไอทีเฉพาะทาง ไมโครเซอร์วิส การติดตั้งบนคลาวด์เนทีฟ ฐานข้อมูลความพร้อมใช้งานสูง และ API เกตเวย์ ออกแบบให้รองรับการเติบโตอย่างมั่นคง',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>`,
    tags: ['Distributed Systems', 'Cloud Native', 'API Gateways', 'Zero-Downtime Migrations', 'DevOps CI/CD'],
    tags_th: ['ระบบกระจายศูนย์', 'คลาวด์เนทีฟ', 'API เกตเวย์', 'ย้ายระบบไร้ดาวน์ไทม์', 'DevOps CI/CD'],
  },

  // ─── Hospitality & Wellness ───
  {
    id: 'hotel-locks',
    category: 'hotel',
    title: 'Smart Hotel Locks & RFID Door Access',
    title_th: 'กลอนประตูดิจิทัลโรงแรม Bluetooth & RFID',
    badge: 'Security & Access',
    badge_th: 'ความปลอดภัย & การเข้า-ออก',
    description: 'Commercial offline-first and online Bluetooth/RFID hotel door locks, master keycard encoders, mobile guest digital keys, and real-time audit-trail logging directly synced with hotel PMS.',
    description_th: 'กลอนประตูดิจิทัลระดับพาณิชย์ ทนไอเค็มทะเล รองรับคีย์การ์ด RFID บัตร Mifare และกุญแจดิจิทัลผ่านสมาร์ทโฟนของแขก Sync ตรงกับระบบบริหารจัดการโรงแรม (PMS)',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>`,
    tags: ['RFID Keycards', 'Bluetooth Mobile Key', 'PMS Key Encoding', 'Audit Trail', 'Battery Health Telemetry'],
    tags_th: ['คีย์การ์ด RFID', 'กุญแจมือถือ Bluetooth', 'เขียนคีย์การ์ดผ่าน PMS', 'บันทึกประวัติเปิดประตู', 'มอนิเตอร์แบตเตอรี่'],
  },
  {
    id: 'spa-booking',
    category: 'hotel',
    title: 'Spa & Wellness Management System',
    title_th: 'ระบบบริหารจัดการสปาและเวลเนส',
    badge: 'Wellness & Spa',
    badge_th: 'เวลเนส & สปา',
    description: 'Intelligent multi-room booking matrix, therapist commission & availability scheduling, dynamic treatment packages, guest wellness preferences, and seamless hotel room folio billing.',
    description_th: 'ตารางจองห้องทรีตเมนต์อัจฉริยะ จัดคิวและคอมมิชชันเธอราปีส แพ็กเกจทรีตเมนต์ยืดหยุ่น บันทึกข้อมูลสุขภาพของลูกค้า และโอนค่าบริการลงบิลห้องพักโรงแรม (Room Folio) อัตโนมัติ',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a10 10 0 0 0-7.07 17.07A10 10 0 1 0 12 2z"></path><path d="M12 6a6 6 0 0 0-4.24 10.24A6 6 0 1 0 12 6z"></path></svg>`,
    tags: ['Therapist Allocation', 'Room Matrix', 'Treatment Packages', 'PMS Guest Folio', 'Commission Payouts'],
    tags_th: ['จัดตารางเธอราปีส', 'ผังห้องทรีตเมนต์', 'แพ็กเกจสปา', 'โอนบิลลงห้องพัก PMS', 'คำนวณคอมมิชชัน'],
  },
  {
    id: 'smart-hotel',
    category: 'hotel',
    title: 'Smart Hotel & Hospitality IoT',
    title_th: 'ระบบโรงแรมอัจฉริยะ & IoT ครบวงจร',
    badge: 'Hospitality Tech',
    badge_th: 'เทคโนโลยีโรงแรมหรู',
    description: 'Next-generation hotel management: seamless PMS integrations, digital self-check-in, automated room environmental IoT (AC, lighting, motorized curtains), and guest mobile concierge.',
    description_th: 'ยกระดับการบริหารโรงแรม: เชื่อมต่อ PMS แบบเรียลไทม์ เช็กอินดิจิทัลด้วยตนเอง ควบคุมระบบแอร์และไฟในห้องพักอัตโนมัติ (IoT) พร้อมแอปพลิเคชันบริการสำหรับแขก',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>`,
    tags: ['PMS Integration', 'IoT Automation', 'Keyless Entry', 'Guest Experience App', 'Automated Folio'],
    tags_th: ['เชื่อมต่อ PMS', 'ระบบอัตโนมัติ IoT', 'เข้าห้องไร้กุญแจ', 'แอปพลิเคชันสำหรับแขก', 'ตัดยอดค่าบริการอัตโนมัติ'],
  },
  {
    id: 'channel-manager',
    category: 'hotel',
    title: 'SaaS Channel Managers & Booking Engines',
    title_th: 'ระบบจัดการช่องทางจำหน่ายห้องพัก (Channel Manager)',
    badge: 'Travel Tech',
    badge_th: 'การตลาดและยอดจอง',
    description: 'Instantaneous 2-way room rate and inventory synchronization across Agoda, Booking.com, Airbnb, Expedia, and Trip.com with zero overbookings and high-converting direct booking engines.',
    description_th: 'เชื่อมโยงราคาและจำนวนห้องว่างแบบ 2 ทิศทางทันทีข้าม Agoda, Booking.com, Airbnb, Expedia และ Trip.com ป้องกัน Overbooking 100% พร้อมระบบรับจองตรงผ่านเว็บไซต์',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>`,
    tags: ['Agoda / Booking.com Sync', 'Rate Parity Engine', 'Direct Booking Widget', 'Payment Gateway'],
    tags_th: ['Sync Agoda / Booking', 'คุมราคาเท่ากันทุกช่องทาง', 'วิดเจ็ตจองตรงบนเว็บ', 'เกตเวย์ชำระเงิน'],
  },

  // ─── POS & Kiosks ───
  {
    id: 'mala-scale-pos',
    category: 'pos',
    title: 'Trade-Scale Integrated Mala POS',
    title_th: 'ระบบคิดเงินและเครื่องชั่งหมาล่ามาตรฐานการค้า',
    badge: 'Specialty F&B Hardware',
    badge_th: 'ฮาร์ดแวร์ร้านอาหารเฉพาะทาง',
    description: 'High-speed weighing checkout for Mala Tang & hotpot venues: sub-millisecond digital scale feed, automated bowl tare deduction, 1-tap broth selector, dynamic PromptPay QR, and <8s queue turnaround.',
    description_th: 'ระบบคิดเงินชั่งน้ำหนักความเร็วสูงสำหรับร้านหมาล่าทั่งและหม้อไฟ: ดึงค่าน้ำหนักดิจิทัลในระดับมิลลิวินาที หักลบน้ำหนักชามอัตโนมัติ เลือกรสชาติน้ำซุป ออก Thai PromptPay QR จบออเดอร์ใน <8 วินาที',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="3" x2="12" y2="21"></line><path d="M6 8l6-5 6 5"></path><path d="M6 16l6 5 6-5"></path></svg>`,
    tags: ['RS-232 Digital Scale', 'Auto Tare Calibration', 'Live Customer Mirror', 'KDS Barcode Ticket', 'PromptPay QR'],
    tags_th: ['เชื่อมต่อตาชั่ง RS-232', 'หักน้ำหนักชามอัตโนมัติ', 'หน้าจอแสดงราคาสด', 'พิมพ์บาร์โค้ดส่งครัว', 'PromptPay QR'],
  },
  {
    id: 'haas-pos-kiosks',
    category: 'pos',
    title: 'Cashier POS & Self-Checkout Kiosks',
    title_th: 'ระบบแคชเชียร์ POS และตู้คีออสบริการตัวเอง',
    badge: 'Hardware & POS',
    badge_th: 'ฮาร์ดแวร์ & ระบบ POS',
    description: 'Turnkey cashier POS setups and intuitive self-checkout kiosks: dual customer-facing displays, high-speed thermal printers, barcode scanners, and cashless Thai PromptPay QR / cards.',
    description_th: 'ชุดอุปกรณ์แคชเชียร์ POS และตู้สั่งอาหาร/ชำระเงินอัตโนมัติ: หน้าจอคู่สำหรับลูกค้า เครื่องพิมพ์สลิปเทอร์มอลความเร็วสูง สแกนเนอร์บาร์โค้ด และรองรับ Thai PromptPay QR และบัตร',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>`,
    tags: ['Cashier POS', 'Self-Checkout Kiosks', 'Dual-Screen Terminals', 'Receipt Printers', 'PromptPay & Cards'],
    tags_th: ['แคชเชียร์ POS', 'ตู้คีออสสั่งอาหาร', 'เทอร์มินอลหน้าจอคู่', 'เครื่องพิมพ์ใบเสร็จ', 'PromptPay & บัตรเครดิต'],
  },

  // ─── Infrastructure & Security ───
  {
    id: 'enterprise-wifi-networking',
    category: 'infra',
    title: 'Network Infrastructure & Enterprise Wi-Fi',
    title_th: 'โครงข่ายไฟเบอร์ & Wi-Fi ระดับองค์กร',
    badge: 'Enterprise Networking',
    badge_th: 'ระบบเครือข่ายองค์กร',
    description: 'High-density commercial Wi-Fi deployments, fiber optic cabling, managed PoE switching, VLAN guest isolation, and captive portals engineered for resorts, hotels, and multi-floor offices.',
    description_th: 'ติดตั้ง Wi-Fi ความหนาแน่นสูงระดับพาณิชย์ เดินสายไฟเบอร์ออปติก สวิตช์ PoE แบบ Managed แยก VLAN แขกและพนักงาน พร้อมหน้า Captive Portal สำหรับรีสอร์ท โรงแรม และอาคารสำนักงาน',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line></svg>`,
    tags: ['Enterprise Wi-Fi 6/7', 'Fiber Structured Cabling', 'Managed PoE Switches', 'Captive Portals', 'VLAN Security'],
    tags_th: ['Enterprise Wi-Fi 6/7', 'สายไฟเบอร์ออปติก', 'สวิตช์ PoE แบบ Managed', 'หน้าล็อกอิน Captive Portal', 'ความปลอดภัย VLAN'],
  },
  {
    id: 'cctv-access-control',
    category: 'infra',
    title: 'CCTV, AI Surveillance & Access Control',
    title_th: 'กล้องวงจรปิด AI ตรวจจับ & ควบคุมการเข้า-ออก',
    badge: 'Security Systems',
    badge_th: 'ระบบความปลอดภัย',
    description: 'Commercial IP surveillance with AI object detection, automated license plate recognition (ALPR), biometric facial turnstiles, and remote cloud video management (VMS) with SLA monitoring.',
    description_th: 'กล้องวงจรปิด IP ความคมชัดสูงพร้อม AI ตรวจจับวัตถุและบุคคล ระบบอ่านป้ายทะเบียนรถอัตโนมัติ (ALPR) ประตูกั้นสแกนใบหน้า และระบบบันทึกภาพบนคลาวด์ (VMS) พร้อมบริการมอนิเตอร์ 24 ชม.',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>`,
    tags: ['4K IP Cameras', 'AI Video Analytics', 'Biometric Turnstiles', 'Cloud NVR', 'Perimeter Alarm'],
    tags_th: ['กล้อง IP 4K', 'AI วิเคราะห์วิดีโอ', 'ประตูกั้นสแกนใบหน้า', 'บันทึกภาพบนคลาวด์', 'ระบบแจ้งเตือนแนวรั้ว'],
  },

  // ─── Custom Engineering & Unlimited IT ───
  {
    id: 'custom-mobile-apps',
    category: 'custom',
    title: 'Custom Mobile & Web Applications',
    title_th: 'พัฒนาแอปพลิเคชันมือถือ & เว็บแอปเฉพาะทาง',
    badge: 'Software Engineering',
    badge_th: 'วิศวกรรมซอฟต์แวร์',
    description: 'Native iOS & Android apps, staff management tablets, guest concierge web apps, and member loyalty portals built with high performance, beautiful UI, and offline-first data sync.',
    description_th: 'แอป iOS & Android แท็บเล็ตจัดการสำหรับพนักงาน เว็บคอนเซียร์จสำหรับแขก และระบบสมาชิกรอยัลตี้ ประสิทธิภาพสูง หน้าตาสวยงามทันสมัย และรองรับการซิงค์ข้อมูลแบบออฟไลน์',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>`,
    tags: ['iOS & Android Apps', 'Staff Portals', 'Member Loyalty CRM', 'Real-Time Sync', 'Custom Dashboards'],
    tags_th: ['แอป iOS & Android', 'พอร์ทัลพนักงาน', 'ระบบสะสมแต้ม CRM', 'ซิงค์ข้อมูลเรียลไทม์', 'แดชบอร์ดเฉพาะทาง'],
  },
  {
    id: 'custom-engineering',
    category: 'custom',
    title: 'Turnkey Custom IT & Hardware Engineering',
    title_th: 'บริการพัฒนาโซลูชันไอทีและฮาร์ดแวร์แบบครบวงจร',
    badge: 'If You Can Think It, We Can Do It',
    badge_th: 'หากคุณคิดได้ เราทำได้จริง',
    description: 'Everything from specialized hardware prototyping and kiosk modifications to custom enterprise microservices. Complete end-to-end IT solutions designed, delivered, and supported under one roof.',
    description_th: 'ตั้งแต่การสร้างต้นแบบฮาร์ดแวร์เฉพาะทาง ปรับแต่งตู้คีออส ไปจนถึงการพัฒนาระบบคลาวด์ไมโครเซอร์วิสระดับองค์กร บริการแบบเทิร์นคีย์ ออกแบบ ส่งมอบ และดูแลตลอด 24 ชั่วโมง',
    icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`,
    tags: ['Hardware Prototyping', 'Embedded Firmware', 'Custom Integrations', 'End-to-End Delivery', '24/7 SLA Support'],
    tags_th: ['ต้นแบบฮาร์ดแวร์', 'เฟิร์มแวร์อุปกรณ์', 'การเชื่อมโยงระบบเฉพาะ', 'ส่งมอบครบวงจร', 'ดูแลตลอด 24 ชม.'],
  },
];

export function initSolutions() {
  const container = document.getElementById('solutions-grid');
  const tabs = document.querySelectorAll('.tab-btn');
  if (!container) return;

  let currentCategory = 'all';

  function render(category = 'all') {
    currentCategory = category;
    const lang = getLanguage();
    const isThai = lang === 'th';

    const filtered = category === 'all' 
      ? SOLUTIONS_DATA 
      : SOLUTIONS_DATA.filter(s => s.category === category);

    if (filtered.length === 0) {
      container.innerHTML = `
        <div style="grid-column: 1 / -1; text-align: center; padding: 40px; color: var(--text-secondary);">
          ${isThai ? 'ไม่พบโซลูชันในหมวดหมู่นี้' : 'No solutions found in this category.'}
        </div>
      `;
      return;
    }

    container.innerHTML = filtered.map(item => {
      const title = isThai && item.title_th ? item.title_th : item.title;
      const badge = isThai && item.badge_th ? item.badge_th : item.badge;
      const desc = isThai && item.description_th ? item.description_th : item.description;
      const tags = isThai && item.tags_th ? item.tags_th : item.tags;

      return `
        <div class="card glass-card solution-card-enter" data-category="${item.category}">
          <div class="card-icon">${item.icon}</div>
          <span class="pill-badge" style="margin-bottom: 14px; font-size: 0.72rem; padding: 4px 12px;">${badge}</span>
          <h3 class="card-title">${title}</h3>
          <p class="card-desc">${desc}</p>
          <div class="tag-list">
            ${tags.map(tag => `<span class="tag-pill">${tag}</span>`).join('')}
          </div>
        </div>
      `;
    }).join('');
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const cat = tab.getAttribute('data-category') || 'all';
      render(cat);
    });
  });

  // Listen to language switch events to instantly update cards in active language
  window.addEventListener('msgtech_lang_changed', () => {
    render(currentCategory);
  });

  render('all');
}
